module.exports = __webpack_public_path__ + "img/TABLE_CREATE.7a7ec775.png";